import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading, startSubmitting } from './_helpers'

export const CREATE_PURCHASE_REQUEST_BATCH = 'purchaseRequestBatches/CREATE_PURCHASE_REQUEST_BATCH'
export const CREATE_PURCHASE_REQUEST_BATCH_FAILURE =
  'purchaseRequestBatches/CREATE_PURCHASE_REQUEST_BATCH_FAILURE'
export const CREATE_PURCHASE_REQUEST_BATCH_SUCCESS =
  'purchaseRequestBatches/CREATE_PURCHASE_REQUEST_BATCH_SUCCESS'

export const DELETE_PURCHASE_REQUEST_BATCH = 'purchaseRequestBatches/DELETE_PURCHASE_REQUEST_BATCH'
export const DELETE_PURCHASE_REQUEST_BATCH_FAILURE =
  'purchaseRequestBatches/DELETE_PURCHASE_REQUEST_BATCH_FAILURE'
export const DELETE_PURCHASE_REQUEST_BATCH_SUCCESS =
  'purchaseRequestBatches/DELETE_PURCHASE_REQUEST_BATCH_SUCCESS'

export const FETCH_PURCHASE_REQUEST_BATCH = 'purchaseRequestBatches/FETCH_PURCHASE_REQUEST_BATCH'
export const FETCH_PURCHASE_REQUEST_BATCH_FAILURE =
  'purchaseRequestBatches/FETCH_PURCHASE_REQUEST_BATCH_FAILURE'
export const FETCH_PURCHASE_REQUEST_BATCH_SUCCESS =
  'purchaseRequestBatches/FETCH_PURCHASE_REQUEST_BATCH_SUCCESS'

export const FETCH_PURCHASE_REQUEST_BATCHES =
  'purchaseRequestBatches/FETCH_PURCHASE_REQUEST_BATCHES'
export const FETCH_PURCHASE_REQUEST_BATCHES_FAILURE =
  'purchaseRequestBatches/FETCH_PURCHASE_REQUEST_BATCHES_FAILURE'
export const FETCH_PURCHASE_REQUEST_BATCHES_SUCCESS =
  'purchaseRequestBatches/FETCH_PURCHASE_REQUEST_BATCHES_SUCCESS'

export const INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT =
  'purchaseRequestBatches/INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT'
export const INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_FAILURE =
  'purchaseRequestBatches/INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_FAILURE'
export const INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_SUCCESS =
  'purchaseRequestBatches/INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_SUCCESS'

export const UPDATE_PURCHASE_REQUEST_BATCH = 'purchaseRequestBatches/UPDATE_PURCHASE_REQUEST_BATCH'
export const UPDATE_PURCHASE_REQUEST_BATCH_FAILURE =
  'purchaseRequestBatches/UPDATE_PURCHASE_REQUEST_BATCH_FAILURE'
export const UPDATE_PURCHASE_REQUEST_BATCH_SUCCESS =
  'purchaseRequestBatches/UPDATE_PURCHASE_REQUEST_BATCH_SUCCESS'

export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS'

export const {
  purchaseRequestBatches: {
    createPurchaseRequestBatch,
    createPurchaseRequestBatchSuccess,
    createPurchaseRequestBatchFailure,
    deletePurchaseRequestBatch,
    deletePurchaseRequestBatchSuccess,
    deletePurchaseRequestBatchFailure,
    fetchPurchaseRequestBatch,
    fetchPurchaseRequestBatchSuccess,
    fetchPurchaseRequestBatchFailure,
    fetchPurchaseRequestBatches,
    fetchPurchaseRequestBatchesSuccess,
    fetchPurchaseRequestBatchesFailure,
    initiatePurchaseRequestBatchPayment,
    initiatePurchaseRequestBatchPaymentSuccess,
    initiatePurchaseRequestBatchPaymentFailure,
    updatePurchaseRequestBatch,
    updatePurchaseRequestBatchSuccess,
    updatePurchaseRequestBatchFailure
  }
} = createActions({
  [CREATE_PURCHASE_REQUEST_BATCH]: undefined,
  [CREATE_PURCHASE_REQUEST_BATCH_FAILURE]: undefined,
  [CREATE_PURCHASE_REQUEST_BATCH_SUCCESS]: undefined,
  [DELETE_PURCHASE_REQUEST_BATCH]: undefined,
  [DELETE_PURCHASE_REQUEST_BATCH_FAILURE]: undefined,
  [DELETE_PURCHASE_REQUEST_BATCH_SUCCESS]: undefined,
  [FETCH_PURCHASE_REQUEST_BATCH]: undefined,
  [FETCH_PURCHASE_REQUEST_BATCH_FAILURE]: undefined,
  [FETCH_PURCHASE_REQUEST_BATCH_SUCCESS]: undefined,
  [FETCH_PURCHASE_REQUEST_BATCHES]: undefined,
  [FETCH_PURCHASE_REQUEST_BATCHES_FAILURE]: undefined,
  [FETCH_PURCHASE_REQUEST_BATCHES_SUCCESS]: undefined,
  [INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT]: undefined,
  [INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_FAILURE]: undefined,
  [INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_SUCCESS]: undefined,
  [UPDATE_PURCHASE_REQUEST_BATCH]: undefined,
  [UPDATE_PURCHASE_REQUEST_BATCH_FAILURE]: undefined,
  [UPDATE_PURCHASE_REQUEST_BATCH_SUCCESS]: undefined
})

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  paginatedData: {
    purchaseRequestBatches: [],
    purchaseRequestBatchesCount: 0,
    purchaseRequestBatchesPageCount: 0
  },
  purchaseRequestBatchObject: null,
  singlePurchaseRequestBatchData: {}
}

export default handleActions(
  {
    [CREATE_PURCHASE_REQUEST_BATCH]: startSubmitting,
    [CREATE_PURCHASE_REQUEST_BATCH_FAILURE]: loadingError,
    [CREATE_PURCHASE_REQUEST_BATCH_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_PURCHASE_REQUEST_BATCH]: state => ({ ...state, isLoading: true }),
    [DELETE_PURCHASE_REQUEST_BATCH_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_PURCHASE_REQUEST_BATCH_FAILURE]: state => ({ ...state, isLoading: false }),
    [FETCH_PURCHASE_REQUEST_BATCH]: startLoading,
    [FETCH_PURCHASE_REQUEST_BATCH_FAILURE]: state => ({
      ...state,
      isLoading: false,
      isError: true,
      singlePurchaseRequestBatchData: { ...state.singlePurchaseRequestBatchData, isError: true }
    }),
    [FETCH_PURCHASE_REQUEST_BATCH_SUCCESS]: (state, { payload }) => ({
      ...state,
      singlePurchaseRequestBatchData: payload,
      isLoading: false,
      isError: false,
      isSuccess: true
    }),
    [FETCH_PURCHASE_REQUEST_BATCHES]: startLoading,
    [FETCH_PURCHASE_REQUEST_BATCHES_FAILURE]: loadingError,
    [FETCH_PURCHASE_REQUEST_BATCHES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        isSuccess: true,
        hasSubmitted: false,
        errorMessage: null
      }

      newState.paginatedData.purchaseRequestBatchesPageCount = payload.pageCount || 0
      newState.paginatedData.purchaseRequestBatchesCount = payload.batchesCount || 0
      newState.paginatedData.purchaseRequestBatches = payload.batches || []

      return newState
    },
    [LOGOUT_SUCCESS]: () => initialState,
    [INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT]: startSubmitting,
    [INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isError: true,
      errorMessage: payload.message
    }),
    [INITIATE_PURCHASE_REQUEST_BATCH_PAYMENT_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        purchaseRequestBatchObject: payload.data,
        isSuccess: true
      }
    },
    [UPDATE_PURCHASE_REQUEST_BATCH]: startSubmitting,
    [UPDATE_PURCHASE_REQUEST_BATCH_FAILURE]: loadingError,
    [UPDATE_PURCHASE_REQUEST_BATCH_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    }
  },
  initialState
)
